import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { fetchFeaturedUni } from '../data-access/+state/featured-university.actions';
import { getStateFeaturedUni } from '../data-access/+state/featured-university.selectors';
import { UniImpressionGADirective, UniProfileGADirective } from '@uc/web/analytics';
import { AsyncPipe } from '@angular/common';
import { EngageCardCtaComponent } from '@web/shared/ui';
import { WriteReviewBtnComponent } from '@uc/web/shared/buttons';
import { RequestBtnComponent, VisitWebsiteBtnComponent } from '@uc/web/shared/leads';

@Component({
	selector: 'uc-featured-university',
	templateUrl: './featured-university.component.html',
	imports: [
		AsyncPipe,
		EngageCardCtaComponent,
		WriteReviewBtnComponent,
		RequestBtnComponent,
		VisitWebsiteBtnComponent,
		UniProfileGADirective,
		UniImpressionGADirective,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturedUniversityComponent implements OnInit {
	featuredUni$ = this._store.select(getStateFeaturedUni);

	constructor(private _store: Store) {}

	ngOnInit(): void {
		this._store.dispatch(fetchFeaturedUni());
	}
}
